import { render, staticRenderFns } from "./SayHello.vue?vue&type=template&id=64c1aab2&"
import script from "./SayHello.vue?vue&type=script&lang=js&"
export * from "./SayHello.vue?vue&type=script&lang=js&"
import style0 from "./SayHello.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports